import { render, staticRenderFns } from "./DoQuestionBzAswer.vue?vue&type=template&id=f215bc84&scoped=true&"
import script from "./DoQuestionBzAswer.vue?vue&type=script&lang=js&"
export * from "./DoQuestionBzAswer.vue?vue&type=script&lang=js&"
import style0 from "./DoQuestionBzAswer.vue?vue&type=style&index=0&id=f215bc84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f215bc84",
  null
  
)

component.options.__file = "DoQuestionBzAswer.vue"
export default component.exports